import * as FiIcons from 'react-icons/fi';

export const navItems = [
  { label: 'Home', target: 'home', icon: FiIcons.FiHome },
  { label: 'About', target: 'about', icon: FiIcons.FiCompass },
  { label: 'Services', target: 'services', icon: FiIcons.FiGrid },
  { label: 'Clients', target: 'clients', icon: FiIcons.FiUsers },
  { label: 'Testimonial', target: 'testimonial', icon: FiIcons.FiMessageSquare },
  { label: 'Contact', target: 'contact', icon: FiIcons.FiSend }
];

export const services = [
  {
    icon: FiIcons.FiSliders,
    title: 'Your rules, your calendar',
    text: 'Shape availability, buffers, lead times, and booking rules around the way you work.'
  },
  {
    icon: FiIcons.FiZap,
    title: 'Launch in an afternoon',
    text: 'Start with proven booking flows and customize the details without a lengthy setup.'
  },
  {
    icon: FiIcons.FiBell,
    title: 'Fewer missed meetings',
    text: 'Keep every appointment on track with timely confirmations and automated reminders.'
  },
  {
    icon: FiIcons.FiBarChart2,
    title: 'See what drives growth',
    text: 'Understand booking activity, popular time slots, and customer behavior at a glance.'
  }
];

export const audiences = [
  { name: 'Entrepreneurs', icon: FiIcons.FiTrendingUp, count: 'Solo & teams' },
  { name: 'Professionals', icon: FiIcons.FiBriefcase, count: 'Consulting' },
  { name: 'Doctors', icon: FiIcons.FiHeart, count: 'Patient care' },
  { name: 'Small business', icon: FiIcons.FiShoppingBag, count: 'Local service' }
];

export const appointments = [
  { time: '09:30', name: 'Discovery call', client: 'Olivia Martin', color: 'mint' },
  { time: '11:00', name: 'Strategy session', client: 'Arjun Patel', color: 'yellow' },
  { time: '14:30', name: 'Follow-up visit', client: 'Mia Thompson', color: 'purple' }
];